<template>
  <div class="dh-psy-animated-image">
    <div aria-hidden class="dh-psy-animated-image__img" :style="opacity">
      <SrcSet :imageId="imageId" />
    </div>
  </div>
</template>

<script>
import SrcSet from './SrcSet.vue'
import normalize from '../../../lib/normalize'

function createAnimation(percent, animations) {
  return animations
    .map(animation => {
      return animation.format(normalize(percent, animation.min, animation.max))
    })
    .join('; ')
}

function ease(value, type = 'quad', power = 3) {
  switch (type) {
    case 'quad':
      return value * value
    case 'pow':
    default:
      return 1 - Math.pow(1 - value, power)
  }
}
export default {
  props: {
    value: {
      type: Number,
      default: 100
    },
    animations: {
      type: Array,
      default: () => {
        return [
          {
            max: 1,
            min: -0.4,
            format: v => `opacity: ${Math.max(v, 0.1)}`
          }
        ]
      }
    },
    imageId: {
      type: String,
      // required: true,
      default: '1.14284983' // '1.14284973'
    }
  },
  computed: {
    opacity() {
      const percent = this.value / 100
      const easedPersent = ease(percent)
      const animation = createAnimation(easedPersent, this.animations)

      return animation
    }
  },
  components: {
    SrcSet
  }
}
</script>

<style scoped lang="postcss">
  .dh-psy-animated-image {
    height: 100%;
    width: 100%;
    position: relative;
    overflow: hidden;
    background: #000;
  }

  .dh-psy-animated-image__img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    contain: strict;
  }
</style>
